import { patientApi } from '@/api/PatientApi'
import { useMutation } from '@tanstack/react-query'

/**
 * Leaves one answer.
 *
 * Nothing is invalidated on success: feedback is written and never read back by the app, so
 * there is no cached answer for a new one to make stale.
 */
export const useLeaveFeedback = () =>
	useMutation({
		mutationFn: ({ score, comment }: { score: number; comment?: string }) =>
			patientApi.leaveFeedback(score, comment),
	})
